import type { SxProps, Theme } from '@mui/material'

/**
 * Shared styles for widget action buttons
 */
export const actionButtonStyles = {
  trigger: {
    '&[data-active="true"]': {
      background: (theme: Theme) => theme.palette.primary.relatedLight,
    },
  },
} satisfies Record<string, SxProps<Theme>>
